export const RoutesParams = {
  id: "id",
  state: "state",
};

const getParam = (param: string) => `:${param}`;

export const RoutesUrl = {
  clients: {
    create: "/dashboard/clients/create",
    list: "/dashboard/clients/list",
    edit: (id?: string) =>
      `/dashboard/clients/edit/${id || getParam(RoutesParams.id)}`,
  },
  gurus: {
    create: "/dashboard/guru/create",
    list: "/dashboard/guru/list",
    edit: (id?: string) =>
      `/dashboard/guru/edit/${id || getParam(RoutesParams.id)}`,
  },
  avatars: {
    create: "/dashboard/avatars/create",
    list: "/dashboard/avatars/list",
    edit: (id?: string) =>
      `/dashboard/avatars/edit/${id || getParam(RoutesParams.id)}`,
  },
  // Parametrics Pro - Module #3
  parametricsPro: {
    create: "/dashboard/parametrics-pro/new-parametrics",
    list: "/dashboard/parametrics-pro/parametrics-data",
    edit: (id?: string) =>
      `/dashboard/parametrics-pro/edit/${id || getParam(RoutesParams.id)}`,
  },
 
  // Market Guru - Modile #5
  // ...
  // ...
  // ...
  // TO DO
  // this is not made yet
  dataBases: {
    list: "/dashboard/dataBases/spisak",
    create: "/dashboard/dataBases/novo",
    edit: (id?: string) =>
      `/dashboard/dataBases/redaktirane/${id || getParam(RoutesParams.id)}`,
  },
  planing: {
    list: "/dashboard/planirane/spisak",
    create: "/dashboard/planirane/novo",
    edit: (id?: string) =>
      `/dashboard/planirane/redaktirane/${id || getParam(RoutesParams.id)}`,
  },
  keyWords: {
    list: "/dashboard/keywords/list",
    create: "/dashboard/keywords/create",
    edit: (id?: string) =>
      `/dashboard/keywords/edit/${id || getParam(RoutesParams.id)}`,
  },
  salesVisualisation: {
    totalRevenue: "/dashboard/sales-visualisation/total-revenue",
    netProfit: "/dashboard/sales-visualisation/net-profit",
  },
  dashboard: {
    orders: "/dashboard/orders",
    reports: "/dashboard/fetch-reports",
    productsProfit: "/dashboard/products-profit",
    products: "/dashboard/products",
    cogs: "/dashboard/cogs",
    inventory: "/dashboard/inventory",
    profitBreakdown: "/dashboard/profit-breakdown",
  },
  orders: "/orders",
  ads: {
    list: "/dashboard/ads/list",
    create: "/dashboard/ads/create",
    edit: (id?: string) =>
      `/dashboard/ads/edit/${id || getParam(RoutesParams.id)}`,
  },
  reports: {
    business: "/business-reports/business",
    inventory: "/business-reports/inventory",
    orders: "/business-reports/orders",
    salesVisualisation: "/business-reports/sales-visualisation/net-profit",
    listings: "/business-reports/listings",
  },
  editor: "/dashboard/editor",
  credentialsForm: "/credentialsForm",
};
